// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zl1_","question":"styles_question__3y3fN","description":"styles_description__2ns0i"};